import type { SEOMeta } from '../../../shared/types/seo.types';
import { SITE_BASE } from '../../../shared/seo/siteUrl';

export const categoriesPageSeo: SEOMeta = {
    title: 'Shop by Category | Arte Craft India',
    description: "Browse handcrafted products by category — Pom Poms & Tassels, Wall Decor, Textiles and more from India's leading craft marketplace.",
    keywords: 'handcrafted categories, pom poms, tassels, wall decor, textiles, artisan crafts india',
    canonical: `${SITE_BASE}/categories`,
    ogTitle: 'Shop by Category | Arte Craft India',
    ogDescription: 'Discover India\'s finest handcrafted product categories.',
    ogType: 'website',
};
